import { templates } from './registry';
import type { HighlightTemplate } from './types';

export function pickTemplateForConcept(
  conceptId: string | null | undefined
): HighlightTemplate {
  const key = conceptId ?? '';
  let hash = 0;
  for (let i = 0; i < key.length; i++) {
    hash = (hash * 31 + key.charCodeAt(i)) | 0;
  }
  const index = Math.abs(hash) % templates.length;
  return templates[index];
}
